import React from "react";
import { useSelector } from "react-redux";

import { Wrapped } from "@components/Layouts";
import Dashboard from "@components/Dashboard";
import { DownloadZipFileButton } from "@components/Admin";
import { getRoleInfo } from "@util/roleInfo";

export default function DashboardPage() {
  const roleInfo = getRoleInfo(useSelector((state) => state));

  return (
    <React.Fragment>
      <Wrapped>
        <Dashboard isAdmin />
        {roleInfo.admin_grandmaster && (
          <div style={{ marginTop: "20px" }}>
            <DownloadZipFileButton />
          </div>
        )}
        <p style={{ marginTop: "20px" }}>
          UKMPTLT:{" "}
          <a href="mailto:imperial.ukmptltstudy@nhs.net">
            imperial.ukmptltstudy@nhs.net
          </a>
        </p>
      </Wrapped>
    </React.Fragment>
  );
}
